import React from 'react';
import { Icon } from 'antd';
import { memoize } from 'lodash';

const style = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  icon: {
    padding: 5,
    fontSize: 20,
  },
};

const checkWriteable = memoize((record, permissions) => {
  if (!record || !permissions) {
    return false;
  }

  return permissions.find(
    permission =>
      permission.operation === 'write' &&
      record.direction === permission.direction &&
      record.game.filter(game => game === permission.game).length,
  );
});

const controlColumn = (
  { onDetailsShow, onFormEdit, onFormClone, permissions },
  title = '',
) => {
  if (!onDetailsShow && !onFormEdit) {
    return null;
  }

  return {
    title,
    dataIndex: '',
    key: 'x',
    width: 128,
    render: (text, record) => {
      const isWriteable = checkWriteable(record, permissions);

      return (
        <div style={style.container}>
          {!!onDetailsShow && (
            <Icon
              type="info-circle"
              style={style.icon}
              onClick={() => onDetailsShow(record.id)}
            />
          )}
          {!!onFormEdit && isWriteable && (
            <Icon
              type="edit"
              style={style.icon}
              onClick={() => onFormEdit(record.id)}
            />
          )}
          {!!onFormClone && isWriteable && (
            <Icon
              type="copy"
              style={style.icon}
              onClick={() => onFormClone(record.id)}
            />
          )}
        </div>
      );
    },
  };
};

export default controlColumn;
